import React from "react";

/**
 * Reusable Live / Sandbox sub-tab strip — used inside provider settings
 * panels (Stripe, Litecard, Provider, Email) to switch the form
 * between editing live and sandbox credential sets. Caller controls
 * state.
 */
export default function EnvironmentSubTabs({ value, onChange }) {
  const tabs = [
    { key: "live",    label: "Live",    color: "var(--success, #16a34a)" },
    { key: "sandbox", label: "Sandbox", color: "var(--warning, #d97706)" },
  ];
  return (
    <div className="env-subtabs">
      {tabs.map((t) => {
        const active = value === t.key;
        return (
          <button
            type="button"
            key={t.key}
            className={`env-subtab ${active ? "is-active" : ""}`}
            style={active ? { borderBottomColor: t.color, color: t.color } : null}
            onClick={() => onChange(t.key)}
          >
            <span className="env-dot" style={{ background: t.color }} />
            {t.label}
          </button>
        );
      })}
      <style>{`
        .env-subtabs {
          display: flex;
          gap: 0.25rem;
          border-bottom: 1px solid var(--border);
          margin: 0 0 1rem;
        }
        .env-subtab {
          background: none;
          border: 0;
          padding: 0.5rem 0.9rem;
          font-size: 0.85rem;
          font-weight: 500;
          color: var(--text-muted);
          cursor: pointer;
          border-bottom: 2px solid transparent;
          margin-bottom: -1px;
          display: inline-flex;
          align-items: center;
          gap: 0.4rem;
          transition: color 0.15s;
        }
        .env-subtab:hover { color: var(--text); }
        .env-subtab.is-active { color: var(--text); border-bottom-color: var(--accent); }
        .env-dot { width: 7px; height: 7px; border-radius: 50%; display: inline-block; }
      `}</style>
    </div>
  );
}
